import { ReactNode } from 'react'
import { Box, CircularProgress } from '@mui/material'
import { useAuth } from '@/hooks/useAuth'
import LoginForm from './LoginForm'

interface AuthGuardProps {
  children: ReactNode
}

const AuthGuard = ({ children }: AuthGuardProps) => {
  const { user, loading } = useAuth()

  // Show loading state while checking auth
  if (loading) {
    return (
      <Box className="flex items-center justify-center min-h-screen">
        <CircularProgress />
      </Box>
    )
  }

  // Show login form if not authenticated
  if (!user) {
    return <LoginForm />
  }

  // Render children if authenticated
  return <>{children}</>
}

export default AuthGuard
